module.exports = __webpack_public_path__ + "static/media/wa-background.13636cb8.png";